var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonKundvagn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.804,
    height: 29.632,
    viewBox: "0 0 29.804 29.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Best\\xE4llningssida",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24180",
    "data-name": "Path 24180",
    d: "M325.611,327.382h2.8a1.368,1.368,0,0,1,1.332,1.055l3.977,16.962,14.853-.045a1.782,1.782,0,0,0,1.7-1.282l3.055-10.461a1.782,1.782,0,0,0-1.726-2.281l-21.05.183",
    transform: "translate(-325.611 -327.382)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24181",
    "data-name": "Path 24181",
    d: "M353.954,365.093H337.225a1.784,1.784,0,0,1-1.784-1.784h0a1.784,1.784,0,0,1,1.784-1.784l1.372-.008",
    transform: "translate(-330.249 -343.488)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_593",
    "data-name": "Ellipse 593",
    cx: 2.52,
    cy: 2.52,
    r: 2.52,
    transform: "translate(8.047 22.591)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_594",
    "data-name": "Ellipse 594",
    cx: 2.52,
    cy: 2.52,
    r: 2.52,
    transform: "translate(17.91 22.591)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonKundvagn);
export default __webpack_public_path__ + "static/media/Ikon_Kundvagn.912daa7a00cdb0b563f7982612dd0ac5.svg";
export { ForwardRef as ReactComponent };